import logo from './logo.svg';
import './App.css';
import Open from './components/open';
import Working from './components/working';
import AboutUs from './components/aboutus';
import Team from './components/team';

function App() {
  return (
    <div className='font-montserrat'>
    <Open/>
    <Working/>
    </div>
  );
}

export default App;
